export enum BiActionType {
  Discard_Changes = 'discard_changes',
  Visibility_Settings = 'visibility_settings_drawer',
  Edit_Url = 'edit_url',
}

export const MY_ACCOUNT_REFERRAL = 'my_account';
